import { GetB2bEmployeesOneResponse } from '@Common/types/bo/b2b/employees';

import { makeChoices } from '@Utils/makeChoices';

export const statusChoices = makeChoices<GetB2bEmployeesOneResponse['status']>({
  current: 'resources.employees.status.current',
  past: 'resources.employees.status.past',
  retired: 'resources.employees.status.retired',
});

export const socialStatusChoices = makeChoices<GetB2bEmployeesOneResponse['social_status']>({
  TS: 'resources.employees.social_status.TS',
  TNS: 'resources.employees.social_status.TNS',
});

export const leavingReasonChoices = makeChoices<
  Exclude<GetB2bEmployeesOneResponse['leaving_reason'], null>
>({
  decease: 'resources.employees.leaving_reason.decease',
  job_transfer: 'resources.employees.leaving_reason.job_transfer',
  retirement: 'resources.employees.leaving_reason.retirement',
  work_ended: 'resources.employees.leaving_reason.work_ended',
  other: 'resources.employees.leaving_reason.other',
});
